// src/firebase/seed.js
// Run this ONCE after setting up Firebase to populate initial data.
// Usage: Import and call seedDatabase() from your admin panel, or run via a script.

import { db } from "./config";
import { collection, addDoc, getDocs } from "firebase/firestore";

const initialNiches = [
  {
    id: "agriculture",
    name: "Agriculture & Organic",
    slug: "agriculture",
    tagline: "Crafted for a Greener Tomorrow",
    description: "Premium organic agricultural solutions to restore soil vitality and promote healthier growth—naturally.",
    icon: "🌱",
    color: "#2C5F2D",
    accentColor: "#97BC62",
    order: 1,
  },
  {
    id: "home-garden",
    name: "Home Gardening",
    slug: "home-garden",
    tagline: "Nurturing Nature Naturally",
    description: "Beautiful, thriving gardens start with the right nutrients. Our home gardening range is designed for every plant lover.",
    icon: "🏡",
    color: "#5C4033",
    accentColor: "#A1887F",
    order: 2,
  },
  {
    id: "landscaping",
    name: "Landscaping & Nurseries",
    slug: "landscaping",
    tagline: "Grow Better, Grow Organic",
    description: "Professional-grade organic solutions for landscapers, nurseries, and commercial growers.",
    icon: "🌿",
    color: "#1B5E20",
    accentColor: "#66BB6A",
    order: 3,
  },
];

const initialProducts = [
  {
    name: "Urvaraa Vermicompost",
    slug: "urvaraa-vermicompost",
    tagline: "Crafted for a Greener Tomorrow",
    description:
      "Urvaraa Vermicompost is a premium organic fertilizer produced through natural decomposition using earthworms. It enhances soil fertility, improves structure, and promotes strong, healthy plant growth.",
    category: "Organic Fertilizers",
    niches: ["agriculture", "home-garden", "landscaping"],
    benefits: [
      "Improves soil aeration",
      "Enhances water retention",
      "Boosts plant growth and yield",
      "Rich in essential nutrients",
      "Promotes root development",
      "100% organic and eco-friendly",
    ],
    usageSuitability: ["Agriculture", "Home gardening", "Nurseries", "Landscaping"],
    howToUse:
      "Mix with soil before planting or apply around plant roots. Water after application for best results.",
    variants: [
      { size: "2 Kg", price: null, sku: "URV-2KG" },
      { size: "5 Kg", price: null, sku: "URV-5KG" },
    ],
    badges: ["100% Organic", "Chemical-Free", "Enhanced Soil Booster"],
    imageUrl: "",
    enquiryEmail: "sales@sunaharco.com",
    featured: true,
    active: true,
    comingSoon: false,
    order: 1,
  },
];

export async function seedDatabase() {
  try {
    // Seed niches
    const nichesRef = collection(db, "niches");
    const existingNiches = await getDocs(nichesRef);
    if (existingNiches.empty) {
      for (const niche of initialNiches) {
        await addDoc(nichesRef, niche);
      }
      console.log("✅ Niches seeded");
    } else {
      console.log("ℹ️ Niches already exist, skipping");
    }

    // Seed products
    const productsRef = collection(db, "products");
    const existingProducts = await getDocs(productsRef);
    if (existingProducts.empty) {
      for (const product of initialProducts) {
        await addDoc(productsRef, {
          ...product,
          createdAt: new Date(),
          updatedAt: new Date(),
        });
      }
      console.log("✅ Products seeded");
    } else {
      console.log("ℹ️ Products already exist, skipping");
    }

    return { success: true };
  } catch (err) {
    console.error("❌ Seed failed:", err);
    return { success: false, error: err.message };
  }
}
